<template>
  <div v-if="languageData.labels !== undefined">
    <v-row>
      <v-col cols="12">
        <TopSection />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row>
          <IncomeChart/>
        </v-row>
        <v-row>
          <LeftSection/>
          <RightSection/>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapActions} from 'vuex';

import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import IncomeChart from "./IncomeChart/IncomeChart";
import TopSection from "./TopSection/TopSection";
import eventBus from "../../../../event-bus/eventBus";


export default {
  name: "MainSection",
  components: {IncomeChart, TopSection, RightSection, LeftSection},
  methods: {
    ...mapActions('getDashboardData', ["getDashboardRequest", "getHeaders", "resetDataLoaded"]),
  },
  mounted() {
    const language = this.getCurrentLanguage;
    this.getHeaders({creds: {language}});
    eventBus.$on("changeLanguage", (value) => {
        const language = value;
        this.getHeaders({creds: {language}});
    });
    this.getDashboardRequest();
    this.updateLanguage(this.getCurrentLanguage);
  },
  beforeDestroy() {
    this.resetDataLoaded();
  }
}
</script>

<style scoped>

</style>